<template>
  <div class="pb-2">
    <fieldset>
        <div class="row">
            <div class="col-md-4 d-flex align-items-center">
                <label class="form-check-label" for="showtracking">Enable Customize Grid</label>
                <b-form-checkbox class="ml-2" switch :false-value="false" :true-value="true" role="switch"
                    v-model="enableCustomizeGridLayout" 
                />
            </div>
            <div class="col-md-4 d-flex align-items-center">
                <label class="form-check-label" for="showtracking">Grid Color</label>
                <input type="text" v-model="bgColorCode" class="form-control" />
            </div>
            <div class="col-md-3 d-flex align-items-center">
                <button type="button"  @click="toggleClientGridSetting()" class="btn btn-primary">Save
                </button>
            </div>
        </div>
    </fieldset>
    <fieldset>
    <div class="row" :class="{'opacity-25': enableCustomizeGridLayout == false}">
        <div class="col-md-12">
            <div class="row justify-content-center">
            <div class="col-md-3">
                <div class="card bg-light fixed-height" :style="[this.client.customize_grid_layout_bg_color ? { background: this.client.customize_grid_layout_bg_color + '!important' } : { background: 'red !important' }]">
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" v-model="gridOneTitle" maxlength="50" class="form-control" placeholder="Under 100 Points">
                            <div class="input-group-append">
                                <button class="btn btn-success" type="button" @click="createCatalogGrid(gridOneTitle,'1 Item',1)"><i class="fas fa-save"></i></button>
                            </div>
                        </div>
                        <div class="">
                            <a href="javascript:void(0)"  @click="openGridItemModal(1,1)"><img :src="gridOneSrc" alt="Test" class="img-thumbnail">
                            <small class="p-2">{{ gridOneTitleOne }}</small></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card bg-light fixed-height" :style="[this.client.customize_grid_layout_bg_color ? { background: this.client.customize_grid_layout_bg_color + '!important' } : { background: 'red !important' }]">
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" v-model="gridTwoTitle" maxlength="30" class="form-control" placeholder="Under 100 Points">
                            <div class="input-group-append">
                                <button class="btn btn-success" type="button" @click="createCatalogGrid(gridTwoTitle,'4 Items',2)"><i class="fas fa-save"></i></button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 pb-2">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(2,1)"><img :src="gridTwoSrcOne" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridTwoTitleOne }}</small></a>
                                </div>
                            </div>
                            <div class="col-md-6 pb-2">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(2,2)"><img :src="gridTwoSrcTwo" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridTwoTitleTwo }}</small></a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(2,3)"><img :src="gridTwoSrcThree" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridTwoTitleThree }}</small></a>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(2,4)"><img :src="gridTwoSrcFour" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridTwoTitleFour }}</small></a>
                                </div>
                            </div>
                        </div>
                        <!--<a class="pt-3" href="">Shop the latest from home</a>-->
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card bg-light fixed-height" :style="[this.client.customize_grid_layout_bg_color ? { background: this.client.customize_grid_layout_bg_color + '!important' } : { background: 'red !important' }]">
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" v-model="gridThreeTitle" maxlength="30" class="form-control" placeholder="Under 100 Points">
                            <div class="input-group-append">
                                <button class="btn btn-success" type="button" @click="createCatalogGrid(gridThreeTitle,'3 Items',3)"><i class="fas fa-save"></i></button>
                            </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                            <div class="">
                                <a href="javascript:void(0)"  @click="openGridItemModal(3,1)"><img :src="gridThreeSrcOne" class="img-thumbnail h-100-px">
                                <small>{{ gridThreeTitleOne }}</small></a>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="">
                                <a href="javascript:void(0)"  @click="openGridItemModal(3,2)"><img :src="gridThreeSrcTwo" alt="Test" class="img-thumbnail h-100-px">
                                <small>{{ gridThreeTitleTwo }}</small></a>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-12">
                            <a href="javascript:void(0)"  @click="openGridItemModal(3,3)"><img :src="gridThreeSrcThree" class="img-thumbnail" style="height: 145px; width: 100%">
                            <small class="pl-1">{{ gridThreeTitleThree }}</small></a>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card bg-light fixed-height" :style="[this.client.customize_grid_layout_bg_color ? { background: this.client.customize_grid_layout_bg_color + '!important' } : { background: 'red !important' }]">
                    <div class="card-body">
                        <div class="input-group mb-3">
                            <input type="text" v-model="gridFourTitle" maxlength="30" class="form-control" placeholder="Under 100 Points">
                            <div class="input-group-append">
                                <button class="btn btn-success" type="button" @click="createCatalogGrid(gridFourTitle,'4 Items',4)"><i class="fas fa-save"></i></button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 pb-2">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(4,1)"><img :src="gridFourSrcOne" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridFourTitleOne }}</small></a>
                                </div>
                            </div>
                            <div class="col-md-6 pb-2">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(4,2)"><img :src="gridFourSrcTwo" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridFourTitleTwo }}</small></a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(4,3)"><img :src="gridFourSrcThree" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridFourTitleThree }}</small></a>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <a href="javascript:void(0)"  @click="openGridItemModal(4,4)"><img :src="gridFourSrcFour" alt="Test" class="img-thumbnail h-100-px">
                                    <small>{{ gridFourTitleFour }}</small></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    </fieldset>
    <b-modal title="Grid Item" size="lg" v-model="gridItemModal" scrollable hide-footer @close="gridItemModal = false">
            <fieldset>
                <div class="row pb-2">
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="form-label">Title</label>
                        &nbsp;<input class="form-control" type="text" v-model="gridItemTitle"/>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="form-label">Image</label>
                        <img v-if="gridItemUploadedImage" :src="gridItemUploadedImage" class="img-thumbnail" height="50px" width="50px" />
                        &nbsp;<input type="file" @change="handleFileUpload( $event )" />
                    </div>
                </div>
                <div class="row pb-2">
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="form-label">Type</label>
                        &nbsp;<select class="form-control" v-model="gridItemType">
                                <option value="None">None</option>
                                <option value="Category">Category</option>
                                <option value="Product">Product</option>
                                <option value="External">External</option>
                            </select>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="form-label">ID/Url</label>
                        &nbsp;<input class="form-control" :disabled="gridItemType == 'None'" type="text" v-model="gridItemData"/>
                    </div>
                </div><hr>
                <div class="row pb-2">
                    <div class="col-md-12 d-flex align-items-center justify-content-center">
                        <button type="button" class="btn btn-primary" :disabled="isDisabled" @click="createGridItem()">Save
                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                        </button>
                    </div>
                </div>
                </fieldset>
    </b-modal>

    <fieldset>
        <div class="row">
            <div class="col-md-4 d-flex align-items-center">
                <label class="form-check-label" for="showtracking">Enable Curated Menu</label>
                <b-form-checkbox class="ml-2" switch :false-value="false" :true-value="true" role="switch"
                    v-model="enableCuratedMenu" 
                />
            </div>
            <div class="col-md-3 d-flex align-items-center">
                <button type="button"  @click="toggleClientCuratedSetting()" class="btn btn-primary">Save
                </button>
            </div>
        </div>
        <hr>
        <div class="row pt-3">
            <div class="col-md-6">
                <div class="input-group mb-3">
                    <input type="text" v-model="menuItemTitle" maxlength="50" class="form-control" placeholder="Enter menu title">
                    <div class="input-group-append">
                        <button class="btn btn-success" type="button" @click="createOrUpdateCuratedItem()">
                            <span v-if="isEditCuratedItem == false">Add</span>
                            <span v-else>Update</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-3">
            <ul class="list-group list-group-horizontal-sm">
                <li class="list-group-item" :style="{ border: '1px solid' }" v-for="item in curatedItems" :key="item.id">
                    <a href="javascriot:void(0)" @click="openCuratedProductsModal(item.id, item.title)">{{ item.title }}</a>&nbsp;
                    <a href="javascriot:void(0)" @click="editCuratedItems(item.id, item.title)"><i class="fas fa-edit"></i></a>&nbsp;
                    <a href="javascriot:void(0)" @click="deleteCuratedItems(item.id, item.title)"><i class="fas fa-trash-alt"></i></a>
                </li>
            </ul>
        </div>
    </fieldset>

    <b-modal :title="currentCuratedItemTitle" size="lg" v-model="menuItemsModal" scrollable hide-footer @close="menuItemsModal = false">
        <fieldset>
            <div class="row">
                <div class="col-md-8">
                    <div class="input-group mb-3">
                        <input type="text" v-model="productId" maxlength="50" class="form-control" placeholder="Enter product id comma separated">
                        <div class="input-group-append">
                            <button class="btn btn-success" type="button" @click="addProductToCuratedItem()">Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <section style="background-color: #eee;">
                <div class="container py-5">
                    <table class="table table-hover table-striped mb-2">
                        <thead>
                        <tr>
                            <th>Image</th>
                            <th>id</th>
                            <th>Name</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody v-if="curatedItemProducts.length > 0">
                            <tr v-for="product in curatedItemProducts" :key="product.product_id">
                                <td>
                                    <img :src="product.image_url" class="img-thumbnail" height="50px" width="50px">
                                </td>
                                <td>{{ product.product_id }}</td>
                                <td>{{ product.name }}</td>
                                <td>
                                    <a href="javascriot:void(0)" class="text-danger" @click="deleteCuratedItemProduct(product.product_id)"><i class="fas fa-trash-alt"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </section>
        </fieldset>
    </b-modal>
  </div>
</template>
<script>
import FrontendService from '../../../../../services/FrontendService';
export default {
  name: "CatalogGrid",
  data() {
    return {
        isDisabled: false,
        
        // Curated Menu
        enableCuratedMenu: false,
        menuItemsModal: false,
        productId: "",
        menuItemTitle: "",
        curatedItems: [],
        currentCuratedItemId: "",
        currentCuratedItemTitle: "",
        curatedItemProducts: [],
        isEditCuratedItem: false,
        

        enableCustomizeGridLayout: false,
        gridOneTitle: "",
        gridOneSrc: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridOneTitleOne: "",

        gridTwoTitle: "",
        gridTwoSrcOne: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridTwoTitleOne: "",

        gridTwoSrcTwo: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridTwoTitleTwo: "",

        gridTwoSrcThree: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridTwoTitleThree: "",

        gridTwoSrcFour: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridTwoTitleFour: "",

        gridThreeTitle: "",
        gridThreeSrcOne: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridThreeTitleOne: "",

        gridThreeSrcTwo: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridThreeTitleTwo: "",

        gridThreeSrcThree: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridThreeTitleThree: "",

        gridFourTitle: "",
        gridFourSrcOne: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridFourTitleOne: "",

        gridFourSrcTwo: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridFourTitleTwo: "",

        gridFourSrcThree: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridFourTitleThree: "",

        gridFourSrcFour: "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg",
        gridFourTitleFour: "",

        gridItemModal: false,

        gridItemTitle: "",
        gridItemType: "None",
        gridItemData: "",
        gridItemPosition: 0,
        gridItemImage: "",
        gridItemUploadedImage: "",
        catalogGridItemId: "",

        catalogGrids: [],
        catalogGridId: "",

    };
  },
  computed: {
    client() { 
      return this.$store.state.manageClients.client;
    },
  },
  methods: {
    toggleClientGridSetting() {
        let data = {
            clientId:this.client.id.toString(),
            enableCustomizeGridLayout: this.enableCustomizeGridLayout,
            bgColorCode: this.bgColorCode
        }
      FrontendService.toggleClientGridSetting(data)
        .then((response) => {
            if (response.status == 200) {
                alert("Catalog grid setting has been updated successfully.")
            } else {
                alert(response.data.error)
            }
        }).catch((e) => {
          alert(e.response.data.message);
        });
    },
    createCatalogGrid(title, type, position) {
        let data = {
            clientId:this.client.id.toString(),
            title: title,
            type: type,
            position: position.toString(),
        }
        FrontendService.createCatalogGrid(data)
        .then((response) => {
            if (response.status == 200) {
                this.getCatalogGrids();
                alert("Grid title has been updated successfully.")
            } else {
                alert(response.data.error)
            }
        }).catch((e) => {
          alert(e.response.data.message);
        });
    },
    openGridItemModal(gridPosition, gridItemPosition) {
        /*if (gridPosition == 1 && this.catalogGrids.length != 1) {
            alert("Please set grid title first");
            return false;
        }
        if (gridPosition == 2 && this.catalogGrids.length != 2) {
            alert("Please set grid title first");
            return false;
        }
        if (gridPosition == 3 && this.catalogGrids.length != 3) {
            alert("Please set grid title first");
            return false;
        }
        if (gridPosition == 4 && this.catalogGrids.length != 4) {
            alert("Please set grid title first");
            return false;
        }*/

        this.gridItemTitle = '';
        this.gridItemType = '';
        this.gridItemData = '';
        this.gridItemUploadedImage = '';
        this.catalogGridItemId = "";
        this.gridItemImage = ""

        let catalogGridId;
        catalogGridId = this.catalogGrids[gridPosition - 1].id;
        if (this.catalogGrids[gridPosition - 1].grid_items.length > 0 && this.catalogGrids[gridPosition - 1].grid_items[gridItemPosition - 1]) {
            this.gridItemTitle = this.catalogGrids[gridPosition - 1].grid_items[gridItemPosition - 1].title;
            this.gridItemType = this.catalogGrids[gridPosition - 1].grid_items[gridItemPosition - 1].redirectionType;
            if (this.gridItemType == "Category" || this.gridItemType == "Product") {
                let str = this.catalogGrids[gridPosition - 1].grid_items[gridItemPosition - 1].redirectionData;
                let n = str.lastIndexOf('/');
                let result = str.substring(n + 1);
                this.gridItemData = result;
            } else {
                this.gridItemData = this.catalogGrids[gridPosition - 1].grid_items[gridItemPosition - 1].redirectionData;   
            }
            this.gridItemUploadedImage = this.catalogGrids[gridPosition - 1].grid_items[gridItemPosition - 1].image_url;
            this.catalogGridItemId = this.catalogGrids[gridPosition - 1].grid_items[gridItemPosition - 1].id;
        }

        /*if (gridPosition == 1) {
            catalogGridId = this.catalogGrids[gridPosition - 1].id;
            this.gridItemTitle = this.catalogGrids[0].grid_items[0].title;
            this.gridItemType = this.catalogGrids[0].grid_items[0].redirectionType;
            this.gridItemData = this.catalogGrids[0].grid_items[0].redirectionData;
            this.gridItemUploadedImage = this.catalogGrids[0].grid_items[0].image_url;
            this.catalogGridItemId = this.catalogGrids[0].grid_items[0].id;
        }
        if (gridPosition == 2) {
            catalogGridId = this.catalogGrids[gridPosition - 1].id;
            this.gridItemTitle = this.catalogGrids[1].grid_items[gridItemPosition - 1].title;
            this.gridItemType = this.catalogGrids[1].grid_items[gridItemPosition - 1].redirectionType;
            this.gridItemData = this.catalogGrids[1].grid_items[gridItemPosition - 1].redirectionData;
            this.gridItemUploadedImage = this.catalogGrids[1].grid_items[gridItemPosition - 1].image_url;
            this.catalogGridItemId = this.catalogGrids[1].grid_items[gridItemPosition - 1].id;
        }
        if (gridPosition == 3) {
            catalogGridId = this.catalogGrids[2].id;
        }
        if (gridPosition == 4) {
            catalogGridId = this.catalogGrids[3].id;
        }*/
        this.gridItemPosition = gridItemPosition;
        this.catalogGridId = catalogGridId;
        this.gridItemModal = true;
    },
    handleFileUpload(event) {
        this.gridItemImage = event.target.files[0];
    },
    createGridItem() {
        this.isDisabled = true;
        let formData = new FormData();
        formData.append("image", this.gridItemImage);
        formData.append("catalogGridId", this.catalogGridId);
        formData.append("clientId", this.client.id.toString());
        formData.append("redirectionType", this.gridItemType);
        formData.append("title", this.gridItemTitle);
        formData.append("redirectionData", this.gridItemData);
        formData.append("position", this.gridItemPosition);
        if (this.catalogGridItemId) {
            formData.append("id", this.catalogGridItemId);
            formData.append("imageURL", this.gridItemUploadedImage);
        }
        FrontendService.createGridItem(formData)
        .then((response) => {
            this.isDisabled = false;
            if (response.status == 200) {
                this.getCatalogGrids();
                this.gridItemModal = false;
                alert("Grid item has been created successfully.")
            } else {
                alert(response.data.error)
            }
        }).catch((e) => {
            this.isDisabled = false;
          console.log({e})
        });
    },
    getCatalogGrids() {
        let data = {
            clientId:this.client.id.toString(),
        }
        FrontendService.getCatalogGrids(data)
        .then((response) => {
            if (response.status != 200) {
                alert(response.data.error)
            } else {
                this.catalogGrids = response.data;
                if (this.catalogGrids.length > 0) {
                    this.gridOneTitle = this.catalogGrids[0].title;
                    this.gridOneSrc = (this.catalogGrids[0].grid_items.length > 0) ? this.catalogGrids[0].grid_items[0].image_url : this.gridOneSrc;
                    this.gridOneTitleOne = (this.catalogGrids[0].grid_items.length > 0) ? this.catalogGrids[0].grid_items[0].title : this.gridOneTitleOne;

                    this.gridTwoTitle = this.catalogGrids[1].title;
                    this.gridTwoSrcOne = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[0].image_url : this.gridTwoSrcOne;
                    this.gridTwoTitleOne = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[0].title : this.gridTwoTitleOne;
                    
                    this.gridTwoSrcTwo = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[1].image_url : this.gridTwoSrcTwo;
                    this.gridTwoTitleTwo = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[1].title : this.gridTwoTitleTwo;

                    this.gridTwoSrcThree = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[2].image_url : this.gridTwoSrcThree;
                    this.gridTwoTitleThree = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[2].title : this.gridTwoTitleThree;

                    this.gridTwoSrcFour = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[3].image_url : this.gridTwoSrcFour;
                    this.gridTwoTitleFour = (this.catalogGrids[1].grid_items.length > 0) ? this.catalogGrids[1].grid_items[3].title : this.gridTwoTitleFour;
    

                    this.gridThreeTitle = this.catalogGrids[2].title;
                    this.gridThreeSrcOne = (this.catalogGrids[2].grid_items.length > 0) ? this.catalogGrids[2].grid_items[0].image_url : this.gridThreeSrcOne;
                    this.gridThreeTitleOne = (this.catalogGrids[2].grid_items.length > 0) ? this.catalogGrids[2].grid_items[0].title : this.gridThreeTitleOne;
                    
                    this.gridThreeSrcTwo = (this.catalogGrids[2].grid_items.length > 0) ? this.catalogGrids[2].grid_items[1].image_url : this.gridThreeSrcTwo;
                    this.gridThreeTitleTwo = (this.catalogGrids[2].grid_items.length > 0) ? this.catalogGrids[2].grid_items[1].title : this.gridThreeTitleTwo;

                    this.gridThreeSrcThree = (this.catalogGrids[2].grid_items.length > 0) ? this.catalogGrids[2].grid_items[2].image_url : this.gridThreeSrcThree;
                    this.gridThreeTitleThree = (this.catalogGrids[2].grid_items.length > 0) ? this.catalogGrids[2].grid_items[2].title : this.gridThreeTitleThree;

                    this.gridFourTitle = this.catalogGrids[3].title;
                    this.gridFourSrcOne = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[0].image_url : this.gridFourSrcOne;
                    this.gridFourTitleOne = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[0].title : this.gridFourTitleOne;
                    
                    this.gridFourSrcTwo = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[1].image_url : this.gridFourSrcTwo;
                    this.gridFourTitleTwo = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[1].title : this.gridFourTitleTwo;

                    this.gridFourSrcThree = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[2].image_url : this.gridFourSrcThree;
                    this.gridFourTitleThree = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[2].title : this.gridFourTitleThree;

                    this.gridFourSrcFour = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[3].image_url : this.gridFourSrcFour;
                    this.gridFourTitleFour = (this.catalogGrids[3].grid_items.length > 0) ? this.catalogGrids[3].grid_items[3].title : this.gridFourTitleFour;
                }
            }
        }).catch((e) => {
          alert(e.response.data.message);
        });
    },
    
    toggleClientCuratedSetting() {
        let data = {
            client_id:this.client.id.toString(),
            enable_curated_list: this.enableCuratedMenu
        }
      FrontendService.toggleClientCuratedSetting(data)
        .then((response) => {
            if (response.status == 200) {
                alert("Curated menu setting has been updated successfully.")
            } else {
                alert(response.data.error)
            }
        }).catch((e) => {
          alert(e.response.data.message);
        });
    },
    createOrUpdateCuratedItem() {
        let data = {
            clientId:this.client.id.toString(),
            title: this.menuItemTitle
        }
        if (this.currentCuratedItemId) {
            data.id = this.currentCuratedItemId.toString();
        }
        FrontendService.createOrUpdateCuratedItem(data)
            .then((response) => {
                if (response.status == 200) {
                    this.menuItemTitle = "";
                    this.isEditCuratedItem = false;
                    this.currentCuratedItemId = "";
                    this.getCuratedList();

                    alert(response.data.message)
                } else {
                    alert(response.data.error);
                    this.menuItemTitle = "";
                    this.isEditCuratedItem = false;
                    this.currentCuratedItemId = "";
                }
            }).catch((e) => {
            alert(e.response.data.message);
            });
    },
    getCuratedList() {
        let data = {
            client_id:this.client.id.toString(),
        }
        FrontendService.getCuratedList(data)
            .then((response) => {
                if (response.status == 200) {  
                    this.curatedItems = response.data;                  
                } else {
                    alert(response.data.error)
                }
            }).catch((e) => {
            alert(e.response.data.message);
            });
    },
    editCuratedItems(id,title) {
        this.isEditCuratedItem = true;
        this.currentCuratedItemId = id;
        this.menuItemTitle = title;
    },
    async deleteCuratedItems(id,title) {
        let text = "Are you sure you want to delete " + title + "?";
        if (confirm(text) == true) {
            let data = {
                curated_item_id: id,
            }
            await FrontendService.deleteCuratedItems(data)
                .then((response) => {
                    if (response.status == 200) {  
                        alert(response.data.message)
                        this.getCuratedList()
                    } else {
                        alert(response.data.error)
                    }
                }).catch((e) => {
                alert(e.response.data.message);
            });
        }
    },
    openCuratedProductsModal(id, title) {
        this.currentCuratedItemId = id;
        this.currentCuratedItemTitle = title;
        this.menuItemsModal = true;
        this.getCuratedProductsList();
    },
    addProductToCuratedItem() {
        let data = {
            id:this.currentCuratedItemId.toString(),
            products: this.productId
        }
        FrontendService.addProductToCuratedItem(data)
            .then((response) => {
                if (response.status == 200) {
                    this.productId = "";
                    this.getCuratedProductsList();
                    alert(response.data.message)
                } else {
                    alert(response.data.error)
                }
            }).catch((e) => {
            alert(e.response.data.message);
            });
    },
    getCuratedProductsList() {
        this.curatedItemProducts = [];
        let data = {
            id:this.currentCuratedItemId.toString(),
        }
        FrontendService.getCuratedProductsList(data)
            .then((response) => {
                if (response.status == 200) {  
                    this.curatedItemProducts = response.data.products;                  
                } else {
                    alert(response.data.error)
                }
            }).catch((e) => {
            alert(e.response.data.message);
            });
    },
    deleteCuratedItemProduct(productId) {
        let data = {
            id:this.currentCuratedItemId.toString(),
            products: productId.toString()
        }
        FrontendService.deleteCuratedItemProduct(data)
            .then((response) => {
                if (response.status == 200) {  
                    this.getCuratedProductsList();
                    alert(response.data.message)
                } else {
                    alert(response.data.error)
                }
            }).catch((e) => {
            alert(e.response.data.message);
            });
    }

  },
  beforeMount() {
      this.enableCustomizeGridLayout = this.client.enable_customize_grid_layout;
      this.enableCuratedMenu = this.client.enable_curated_items;
      this.bgColorCode = this.client.customize_grid_layout_bg_color
      this.getCatalogGrids();
      this.getCuratedList();
  }
};
</script>
<style scoped>
.nav-pills > .active > a, .nav-pills > .active > a:hover, .nav-pills > .active > a:focus {
    color: #ffffff;
    background-color: #0088cc;
}
.border-right {
  border-right: solid 2px;
}
.h-100-px {
  height: 100px;
}
.fixed-height {
  height: 370px;
}
.opacity-25 {
    opacity: 0.2;
}
</style>